
import "../CSS/raum.css";

function RaumPage() {
    return (
        <>
            <div className="intro">
                <h1>Mein Massageraum im Sarganserland</h1>
                <p>Dies ist der Raum, wo wir uns treffen werden.</p>
            </div>

            <main className="raum-main">

                {/* VIDEO UND CHARTA */}
                <section className="raum-einstieg">

                    <figure className="raum-medium">
                        <video
                            className="raum-video"
                            autoPlay
                            loop
                            controls
                            playsInline
                        >
                            <source
                                src="/Fotos/raum/raum.mp4"
                                type="video/mp4"
                            />
                            Dein Browser unterstützt keine Videos.
                        </video>

                        <figcaption>
                            Ein kleiner Einblick in meinen Massageraum
                        </figcaption>
                    </figure>

                    {/* CHARTA RECHTS NEBEN DEM VIDEO */}
                    <section
                        className="raum-charta"
                        aria-labelledby="raum-charta-titel"
                    >
                        <div className="raum-charta-kopf">
                            <p className="raum-charta-werte">
                                ACHTSAMKEIT • VERTRAUEN • RESPEKT • PRÄSENZ
                            </p>

                            <h2 id="raum-charta-titel">
                                Charta dieses Raumes
                            </h2>

                            <p className="raum-charta-einleitung">
                                Dieser Raum ist der Ruhe, der Achtsamkeit
                                und der respektvollen Begegnung gewidmet.
                                Wer ihn betritt, begegnet sich selbst und
                                seinem Gegenüber mit Offenheit, Klarheit
                                und Wertschätzung.
                            </p>
                        </div>

                        <div className="raum-charta-grundsaetze">

                            <div className="raum-charta-grundsatz">
                                <h3>Achtsamkeit</h3>
                                <p>
                                    Wir begegnen uns mit Präsenz,
                                    Respekt und Wertschätzung.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Vertrauen</h3>
                                <p>
                                    Alles, was in diesem Raum geschieht
                                    und gesprochen wird, wird
                                    vertraulich behandelt.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Grenzen</h3>
                                <p>
                                    Jeder Mensch bestimmt seine eigenen
                                    Grenzen. Ein Ja darf sich verändern.
                                    Ein Nein wird jederzeit respektiert.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Kommunikation</h3>
                                <p>
                                    Wünsche, Unsicherheiten und Grenzen
                                    dürfen jederzeit offen ausgesprochen
                                    werden.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Freiwilligkeit</h3>
                                <p>
                                    Jede Berührung geschieht bewusst
                                    und im gegenseitigen Einverständnis.
                                    Nichts wird vorausgesetzt oder erwartet.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Respekt</h3>
                                <p>
                                    Körper, Persönlichkeit und
                                    Individualität werden ohne
                                    Bewertung angenommen.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Präsenz</h3>
                                <p>
                                    Für die gemeinsame Zeit dürfen Alltag,
                                    Telefon und äussere Ablenkungen
                                    draussen bleiben.
                                </p>
                            </div>

                            <div className="raum-charta-grundsatz">
                                <h3>Verantwortung</h3>
                                <p>
                                    Wir tragen gemeinsam dazu bei, dass
                                    dieser Raum ein geschützter, achtsamer
                                    und respektvoller Ort bleibt.
                                </p>
                            </div>

                        </div>

                        <p className="raum-charta-abschluss">
                            „Mit dem Betreten dieses Raumes begegnen
                            wir einander in dieser Haltung.“
                        </p>

                        <a
                            className="raum-charta-pdf"
                            href="/Fotos/raum/Charta.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Original-Charta als PDF ansehen
                        </a>
                    </section>

                    {/* BESTEHENDE RAUMBESCHREIBUNG */}
                    <div className="raum-text">
                        <h2>Ein Ort für Ruhe und achtsame Begegnung</h2>

                        <p>
                            In meinem Massageraum im Sarganserland
                            erwartet Dich eine ruhige und entspannte
                            Atmosphäre für Deine Tantramassage.
                        </p>

                        <p>
                            Der Raum ist auch aus der Region Mels,
                            Sargans und Bad Ragaz gut erreichbar.
                        </p>

                        <p>
                            Die genaue Adresse gebe ich Dir bei
                            Terminabmachung bekannt.
                        </p>
                    </div>

                </section>

                {/* BILDERGALERIE */}
                <section className="raum-galerie-bereich">

                    <h2>Einblicke in den Raum</h2>

                    <div className="raum-galerie">

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum1.jpg"
                                alt="Massageraum von IRJ-Tantramassagen im Sarganserland"
                            />
                            <figcaption>
                                Blick in den Massageraum
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum2.jpg"
                                alt="Massagebereich für Tantramassagen"
                            />
                            <figcaption>
                                Der Massagebereich
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum3.jpeg"
                                alt="Besprechungsecke im Massageraum"
                            />
                            <figcaption>
                                Besprechungsecke
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum4.jpeg"
                                alt="Einblick in den Massageraum"
                            />
                            <figcaption>
                                Regal links
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum5.jpeg"
                                alt="Beleuchteter Massagebereich"
                            />
                            <figcaption>
                                Massagebereich mehr beleuchtet
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum6.jpeg"
                                alt="Massagebereich von IRJ-Tantramassagen"
                            />
                            <figcaption>
                                Massagebereich
                            </figcaption>
                        </figure>

                        <figure className="raum-bild">
                            <img
                                src="/Fotos/raum/raum8.jpeg"
                                alt="Weitere Ansicht des Massageraums"
                            />
                            <figcaption>
                                Seite rechts
                            </figcaption>
                        </figure>

                    </div>
                </section>

            </main>
        </>
    );
}

export default RaumPage;
